// 概览「持仓汇总」与标签筛选的纯函数（AC-102 / AC-103）。金额来自后端 Decimal 字符串，这里只做展示级求和。

function missing(value) {
  return value === null || value === undefined || value === "";
}

function num(value) {
  return missing(value) ? null : Number(value);
}

// 剩余持仓的成本：后端 cost_basis_remaining，缺失时兜底 持股数 × 成本价（同 AssetOverview 原逻辑）。
export function holdingTotalCost(metrics) {
  if (!missing(metrics.cost_basis_remaining)) return metrics.cost_basis_remaining;
  if (missing(metrics.quantity) || missing(metrics.cost_per_share)) return null;
  return Number(metrics.quantity) * Number(metrics.cost_per_share);
}

export function rowTagLabels(row) {
  return (row.tags ?? []).map((tag) => tag.label).filter(Boolean);
}

// 满足任一所选标签即保留；没选就是全部。
export function filterByTags(rows, selected) {
  if (!selected?.length) return rows;
  const wanted = new Set(selected);
  return rows.filter((row) => rowTagLabels(row).some((label) => wanted.has(label)));
}

// 每个标签下的行数（下拉里的计数），按行数降序、同数按名字。
export function tagCounts(rows) {
  const counts = new Map();
  for (const row of rows) for (const label of new Set(rowTagLabels(row))) counts.set(label, (counts.get(label) ?? 0) + 1);
  return [...counts].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], "zh-CN"));
}

// 只加「算得出来」的行：市值 / 总盈亏 / 总成本任一缺失就整行跳过，不猜、也不显示「N 只未计入」。
export function summarizeHoldings(rows) {
  const sum = { today_pnl: 0, prev_market_value: 0, total_cost: 0, market_value: 0, dividend_income: 0,
    realized_pnl: 0, total_profit: 0, invested: 0, count: 0 };
  let hasToday = false;
  for (const row of rows) {
    const m = row.metrics ?? {};
    const cost = num(holdingTotalCost(m));
    const marketValue = num(m.market_value);
    const profit = num(m.total_profit);
    if (cost === null || marketValue === null || profit === null) continue;
    sum.count += 1;
    sum.total_cost += cost;
    sum.market_value += marketValue;
    sum.total_profit += profit;
    sum.dividend_income += num(m.dividend_income) ?? 0;
    sum.realized_pnl += num(m.realized_pnl) ?? 0;
    sum.invested += num(m.invested_cost) ?? 0;
    // 今日盈亏只加两个字段都有的行（场外基金、只有一个点的持仓没有），涨跌幅的分母同口径。
    const today = num(m.today_pnl);
    const prev = num(m.prev_market_value);
    if (today !== null && prev !== null) {
      sum.today_pnl += today;
      sum.prev_market_value += prev;
      hasToday = true;
    }
  }
  return {
    count: sum.count,
    today_pnl: hasToday ? sum.today_pnl : null,
    today_pct: hasToday && sum.prev_market_value > 0 ? sum.today_pnl / sum.prev_market_value : null,
    total_cost: sum.count ? sum.total_cost : null,
    market_value: sum.count ? sum.market_value : null,
    dividend_income: sum.count ? sum.dividend_income : null,
    realized_pnl: sum.count ? sum.realized_pnl : null,
    unrealized_pnl: sum.count ? sum.market_value - sum.total_cost : null,
    total_profit: sum.count ? sum.total_profit : null,
    book_total_return: sum.count && sum.invested > 0 ? sum.total_profit / sum.invested : null,
  };
}
